import React, { useState } from "react";
import { ChevronDown, ChevronRight, Trophy, GraduationCap } from "lucide-react";

const GOLD = "#C9A84C";
const slug = (s) => s.toLowerCase().replace(/\s+/g, "-");

export const EventCoachRanking = ({ coaches, competitionName }) => {
  const [expanded, setExpanded] = useState(null);
  const toggle = (key) => setExpanded((e) => (e === key ? null : key));

  return (
    <div className="mt-10" data-testid="event-coach-ranking">
      <div className="mb-4">
        <div className="overline mb-2 flex items-center gap-1">
          <GraduationCap size={12} /> Treinadores neste evento
        </div>
        <h2 className="font-display text-3xl font-black tracking-tight">
          RANKING DE TREINADORES DO EVENTO
        </h2>
        <div className="text-xs text-[var(--text-secondary)] mt-1">
          {competitionName ? `${competitionName} · ` : ""}
          1º=10 · 2º=8 · 3º=6 · 4º=4 · 5º=3 · 6º=2 · Participação=1 · Bônus +5 com 5+ atletas.
          O ranking anual em <b>Treinadores</b> não é afetado.
        </div>
      </div>

      <div className="card overflow-x-auto">
        <table className="table-dense" data-testid="event-coach-table">
          <thead>
            <tr>
              <th className="w-14">Pos</th>
              <th>Treinador</th>
              <th>Equipe</th>
              <th className="text-center">Atletas</th>
              <th className="text-center">Colocações</th>
              <th className="text-center">Bônus</th>
              <th className="text-right pr-4">Total</th>
              <th className="w-10"></th>
            </tr>
          </thead>
          <tbody>
            {coaches.length === 0 && (
              <tr>
                <td colSpan={8} className="text-center py-8 text-[var(--text-secondary)]">
                  Nenhum treinador neste evento. Cadastre atletas com o campo <b>Treinador</b>{" "}
                  preenchido.
                </td>
              </tr>
            )}
            {coaches.map((c) => (
              <CoachRow key={c.coach} c={c} open={expanded === c.coach} onToggle={() => toggle(c.coach)} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const CoachRow = ({ c, open, onToggle }) => (
  <>
    <tr
      data-testid={`event-coach-row-${slug(c.coach)}`}
      className="cursor-pointer hover:bg-white/5"
      onClick={onToggle}
    >
      <td className="tabular-nums font-display font-black text-2xl text-[#C9A84C]">{c.posicao}</td>
      <td className="font-semibold">
        <span className="inline-flex items-center gap-2">
          {c.posicao === 1 && <Trophy size={14} style={{ color: GOLD }} />}
          {c.coach}
        </span>
      </td>
      <td className="text-xs text-[var(--text-secondary)]">{c.equipe || "—"}</td>
      <td className="text-center tabular-nums">
        {c.unique_athlete_count}
        <span className="text-[10px] text-[var(--text-secondary)] ml-1">({c.athlete_count} insc.)</span>
      </td>
      <td className="text-center tabular-nums">{c.points_from_placements}</td>
      <td className="text-center tabular-nums">
        {c.volume_bonus > 0 ? (
          <span
            className="px-1.5 py-0.5 text-[9px] font-bold tracking-widest"
            style={{ background: GOLD, color: "#0a0a0a" }}
          >
            +{c.volume_bonus}
          </span>
        ) : (
          "—"
        )}
      </td>
      <td
        className="text-right pr-4 tabular-nums font-display font-black text-2xl"
        data-testid={`event-coach-total-${slug(c.coach)}`}
      >
        {c.total_points}
      </td>
      <td className="text-right pr-2">{open ? <ChevronDown size={16} /> : <ChevronRight size={16} />}</td>
    </tr>
    {open && (
      <tr data-testid={`event-coach-detail-${slug(c.coach)}`}>
        <td colSpan={8} className="bg-black/40 px-6 py-4">
          <div className="overline mb-2" style={{ color: GOLD }}>
            Colocações dos atletas
          </div>
          <table className="w-full text-sm">
            <tbody>
              {c.placements.map((p) => (
                <tr key={p.athlete_id} className="border-t border-white/5">
                  <td className="py-1 tabular-nums font-bold w-10">{p.posicao ? `${p.posicao}º` : "—"}</td>
                  <td className="py-1">{p.athlete_name}</td>
                  <td className="py-1 text-[11px] text-[var(--text-secondary)]">{p.category_name}</td>
                  <td className="py-1 text-right pr-2 tabular-nums font-bold">{p.points} pt</td>
                </tr>
              ))}
            </tbody>
          </table>
        </td>
      </tr>
    )}
  </>
);
